<template>
  <div class="modal fade" id="addEditSubjectModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <i
            v-if="editing"
            class="material-icons pointer pt-1 pr-2"
            role="button"
            v-on:click="page = -1"
            id="archive"
            @mouseover="$showTooltip('#archive')"
            @mouseleave="$hideTooltip('#archive')"
            data-placement="top"
            title="Archive this subject and all student and unit data associated with it."
            >archive</i
          >
          <h5 v-if="!editing" class="modal-title">New Subject</h5>
          <h5 v-if="editing" class="modal-title">Edit Subject</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Confirm Archive -->
          <div v-if="page == -1">
            <h5>
              Are you sure you want to archive this subject and all of the
              related units and data?
            </h5>
            <div class="row">
              <div class="col text-left">
                <button
                  type="button"
                  v-on:click="page = 1"
                  class="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
              <div class="col-auto">
                <button
                  type="button"
                  v-on:click="archiveSubject"
                  class="btn btn-primary"
                >
                  Archive Subject
                </button>
              </div>
            </div>
          </div>

          <form v-if="page == 1" @submit.prevent="nextPage">
            <div class="form-group">
              <label v-if="Organization != null">{{ Organization.Name }}</label>
            </div>
            <div class="form-group">
              <label for="name">Subject Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Subject Name"
                v-model="newSubjectName"
                required
              />
            </div>
            <div class="form-group">
              <label for="description">Subject Description</label>
              <input
                type="text"
                class="form-control"
                id="description"
                placeholder="Subject Description"
                v-model="newSubjectDescription"
              />
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                Next
              </button>
            </div>
          </form>
          <form v-if="this.page == 2" @submit.prevent="nextPage">
            <label>Students</label>
            <div class="row text-left">
              <div
                v-for="student in Students.slice().sort($orderByName)"
                :key="student.Student_Id"
                class="col-6"
              >
                <label
                  class="btn btn-sm"
                  v-bind:for="student.Student_Id"
                  v-bind:class="{
                    'btn-primary': selectedStudents.includes(
                      student.Student_Id
                    ),
                    'btn-outline-primary': !selectedStudents.includes(
                      student.Student_Id
                    )
                  }"
                >
                  <input
                    style="display: none"
                    type="checkbox"
                    v-bind:name="student.Student_Id"
                    v-bind:id="student.Student_Id"
                    v-bind:value="student.Student_Id"
                    v-model="selectedStudents"
                  />{{ student.Name }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col text-left">
                <button
                  type="button"
                  v-on:click="previousPage"
                  class="btn btn-danger"
                >
                  Back
                </button>
              </div>
              <div class="col-auto">
                <button type="submit" class="btn btn-primary">
                  Next
                </button>
              </div>
            </div>
          </form>
          <form v-if="this.page == 3" @submit.prevent="submitSubject">
            <label>Subject Permission</label>
            <div
              v-for="user in users
                .filter(u => u.User_Id != $store.getters.user.User_Id)
                .sort($orderByLastName)"
              :key="user.User_Id"
              class="form-group form-check"
            >
              <div v-if="Organization != null">
                <label class="form-check-label" v-bind:for="user.User_Id"
                  >{{ user.First_Name }} {{ user.Last_Name }}</label
                >
                <label
                  class="d-block"
                  v-if="
                    user.Permissions.some(
                      p =>
                        p.Organization_Id == Organization.Organization_Id &&
                        p.Permission_Id == 4
                    )
                  "
                  ><small>
                    This user has management permissions through
                    {{ Organization.Name }}.
                  </small></label
                >
              </div>
              <div
                v-for="permission in allPermissions.filter(
                  g => g.Permission_Type.Permission_Type_Id == '3'
                )"
                :key="user.User_Id + 'sub' + permission.Permission_Id"
              >
                <label
                  class="btn btn-sm"
                  v-bind:for="user.User_Id + 'sub' + permission.Permission_Id"
                  v-bind:class="{
                    'btn-primary': selectedUserPermissions.some(
                      i =>
                        i.user == user.User_Id &&
                        i.permission == permission.Permission_Id
                    ),
                    'btn-outline-primary': !selectedUserPermissions.some(
                      i =>
                        i.user == user.User_Id &&
                        i.permission == permission.Permission_Id
                    )
                  }"
                >
                  <input
                    style="display: none"
                    type="checkbox"
                    v-bind:name="
                      user.User_Id + 'sub' + permission.Permission_Id
                    "
                    v-bind:id="user.User_Id + 'sub' + permission.Permission_Id"
                    v-bind:value="{
                      user: user.User_Id,
                      permission: permission.Permission_Id
                    }"
                    v-model="selectedUserPermissions"
                  />{{ permission.Title }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col text-left">
                <button
                  type="button"
                  v-on:click="previousPage"
                  class="btn btn-danger"
                >
                  Back
                </button>
              </div>
              <div class="col-auto">
                <button v-if="!editing" type="submit" class="btn btn-primary">
                  Create Subject
                </button>
                <button v-if="editing" type="submit" class="btn btn-primary">
                  Update Subject
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "AddEditSubjectModal",
  props: {
    Organization: Object,
    Students: Array,
    Subject: Object
  },
  data() {
    return {
      newSubjectName: "",
      newSubjectDescription: "",
      editing: false,
      page: 1,
      selectedStudents: [],
      originalStudents: [],
      users: [],
      selectedUserPermissions: [],
      originalUserPermissions: [],
      allPermissions: []
    };
  },
  watch: {
    Subject: function() {
      if (this.Subject != null) {
        this.newSubjectName = this.Subject.Title;
        this.newSubjectDescription = this.Subject.Description;
        this.editing = true;
        this.page = 1;
        this.selectedStudents = this.Students.filter(s =>
          s.Subjects.map(su => su.Subject_Id).includes(this.Subject.Subject_Id)
        ).map(s => s.Student_Id);
        this.originalStudents = this.Students.filter(s =>
          s.Subjects.map(su => su.Subject_Id).includes(this.Subject.Subject_Id)
        ).map(s => s.Student_Id);
        this.getUsersPermissions();
      } else {
        this.editing = false;
        this.clearFields();
      }
    },
    Organization: async function() {
      if (this.Organization != null) {
        await this.$queryUsers(
          [this.Organization.Parent_Organization_Id],
          null
        ).then(users => {
          this.users = users;
          this.page = 1;
          this.getUsersPermissions();
        });
      }
    }
  },
  async mounted() {
    var view = this;
    $("#addEditSubjectModal").on("hidden.bs.modal", function() {
      if (view.editing) {
        view.$emit("edit-closed");
      }
    });
    $("#addEditSubjectModal").on("shown.bs.modal", function() {
      $("#name").focus();
    });
    this.allPermissions = await this.$getAllPermissions();
  },
  methods: {
    nextPage() {
      this.page += 1;
    },
    previousPage() {
      this.page -= 1;
    },
    getUsersPermissions() {
      if (this.Subject != null) {
        this.selectedUserPermissions = [];
        this.users.forEach(user => {
          var permissions = user.Permissions.filter(
            p => p.Subject_Id == this.Subject.Subject_Id
          );
          permissions.forEach(permission => {
            this.selectedUserPermissions.push({
              user: user.User_Id,
              permission: permission.Permission_Id
            });
            this.originalUserPermissions.push({
              user: user.User_Id,
              permission: permission.Permission_Id
            });
          });
        });
      }
    },
    async submitSubject() {
      if (!this.editing) {
        await this.createSubject();
      } else {
        await this.updateSubject();
      }
    },
    async createSubject() {
      $("#addEditSubjectModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var subjectToCreate = {
        Title: view.newSubjectName,
        Description: view.newSubjectDescription,
        Organization_Id: view.Organization.Organization_Id,
        Units: [],
        Students: []
      };

      await this.$createSubject(subjectToCreate)
        .then(async newSubject => {
          var studentsToAdd = [];
          this.selectedStudents.forEach(studentId => {
            studentsToAdd.push({
              studentId: studentId,
              subjectIds: [newSubject.Subject_Id]
            });
          });
          await this.$createStudentSubjectsPairs(studentsToAdd).then(
            async () => {
              await Promise.all(
                this.selectedUserPermissions
                  .filter(p => !this.originalUserPermissions.includes(p))
                  .map(async userPermission => {
                    await this.$createUserPermissionsForSubjects(
                      userPermission.user,
                      [
                        {
                          subject: newSubject.Subject_Id,
                          permission: userPermission.permission
                        }
                      ]
                    );
                  })
              ).then(() => {
                //view.$store.commit("updateLoading", false);
                view.$emit("added-subject", newSubject, this.selectedStudents);
              });
            }
          );
          this.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#addEditSubjectModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async updateSubject() {
      $("#addEditSubjectModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var subjectToUpdate = view.Subject;
      subjectToUpdate.Title = view.newSubjectName;
      subjectToUpdate.Description = view.newSubjectDescription;

      await this.$updateSubject(subjectToUpdate)
        .then(async updatedSubject => {
          var studentsToAdd = [];
          this.selectedStudents
            .filter(s => !this.originalStudents.includes(s))
            .forEach(studentId => {
              studentsToAdd.push({
                studentId: studentId,
                subjectIds: [this.Subject.Subject_Id]
              });
            });
          var studentsToArchive = [];
          this.originalStudents
            .filter(s => !this.selectedStudents.includes(s))
            .forEach(studentId => {
              studentsToArchive.push({
                studentId: studentId,
                subjectIds: [this.Subject.Subject_Id]
              });
            });
          await this.$createStudentSubjectsPairs(studentsToAdd).then(
            async () => {
              await this.$archiveStudentSubjectsPairs(studentsToArchive).then(
                async () => {
                  var permissionstoRemove = [];
                  var removedUserPermissions = this.originalUserPermissions.filter(
                    p => !this.selectedUserPermissions.includes(p)
                  );
                  removedUserPermissions.forEach(rp => {
                    permissionstoRemove.push(
                      this.users
                        .find(u => u.User_Id == rp.user)
                        .Permissions.find(
                          p =>
                            p.Subject_Id == this.Subject.Subject_Id &&
                            p.Permission_Id == rp.permission
                        ).User_Permission_Id
                    );
                  });
                  await this.$removeUserPermissions(permissionstoRemove);
                  await Promise.all(
                    this.selectedUserPermissions
                      .filter(p => !this.originalUserPermissions.includes(p))
                      .map(async userPermission => {
                        await this.$createUserPermissionsForSubjects(
                          userPermission.user,
                          [
                            {
                              subject: this.Subject.Subject_Id,
                              permission: userPermission.permission
                            }
                          ]
                        );
                      })
                  );
                  await this.getUsersPermissions();
                  //view.$store.commit("updateLoading", false);
                  view.$emit("edited-subject", updatedSubject);
                  this.clearFields();
                }
              );
            }
          );
        })
        .catch(e => {
          console.log(e);
          $("#addEditSubjectModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.newSubjectName = "";
      this.newSubjectDescription = "";
      this.selectedUserPermissions = [];
    },
    async archiveSubject() {
      $("#addEditSubjectModal").modal("hide");
      this.$store.commit("updateLoading", true);
      await this.$archiveSubject(this.Subject.Subject_Id);
      this.$store.commit("updateLoading", false);
      this.$emit("subject-archived", this.Subject);
    }
  }
};
</script>
